export class DownloadFile {

    static get $inject() {

        return [
            '$window',
            'AbstractPmsApiService',
        ];
    }

    constructor(window, AbstractPmsApiService) {

        this.window = window;
        this.navigator = window.navigator;
        this.document = window.document;
        this.AbstractPmsApiService = AbstractPmsApiService;
    }

    fetchFile(url, name = null) {

        const pmsService = this.AbstractPmsApiService;
        const dataService = url => fetch(url, {
            method: 'GET',
            headers: pmsService.authHeaders,
        });

        return dataService(url)
            .then(response => {
                if (response.status < 200 || response.status >= 400) {
                    return Promise.reject({status: response.status, data:response.json()})
                }

                return response;
            })
            .then(response => response.blob())
            .then(data => {

                this.downloadAsBlob(data, name);
            })
            .catch(pmsService.getErrorHandler());
    }

    downloadAsBlob(data, name = null) {

        const blob = new Blob([data], {type: data.type || 'application/octet-stream'});
        const url = window.URL.createObjectURL(blob);
        this.download(url, name);
        window.URL.revokeObjectURL(url);
    }

    download(url, name = null) {

        //iOS devices do not support downloading. We have to inform user about this.
        if (/(iP)/g.test(this.navigator.userAgent)) {

            this.window.open(url, '_blank');
            return false;
        }

        //If in Chrome or Safari - download via virtual link click
        if (this.isEverGreen()) {

            const link = this.document.createElement('a');
            link.href = url;
            if (this.isChrome() || this.isSafari()) {

                link.setAttribute('target', '_blank');
            }

            if (angular.isDefined(link.download)) {

                link.download = name || url.substring(url.lastIndexOf('/') + 1, url.length);
            }

            if (this.document.createEvent) {

                const e = this.document.createEvent('MouseEvents');
                e.initEvent('click', true, true);
                link.dispatchEvent(e);
                return true;
            }
        }

        this.window.open(url, '_blank');
        return true;
    }

    isEverGreen() {

        return [
            this.isChrome(),
            this.isSafari(),
            this.isFirefox(),
        ].some(isBrowser=> isBrowser);
    }

    isChrome() {

        return this.isBrowser('chrome');
    }

    isSafari() {

        return this.isBrowser('safari');
    }

    isFirefox() {

        return this.isBrowser('mozilla');
    }

    isBrowser(tag) {

        return this.navigator.userAgent.toLowerCase().indexOf(tag) > -1;
    }
}



// WEBPACK FOOTER //
// ./src/app/services/download-file.js